import { render, staticRenderFns } from "./ArticleSlider.vue?vue&type=template&id=aade28b6&scoped=true"
import script from "./ArticleSlider.vue?vue&type=script&lang=js"
export * from "./ArticleSlider.vue?vue&type=script&lang=js"
import style0 from "./ArticleSlider.vue?vue&type=style&index=0&id=aade28b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aade28b6",
  null
  
)

export default component.exports